import { render, staticRenderFns } from "./folderDetails.vue?vue&type=template&id=0861470a&scoped=true"
import script from "./folderDetails.vue?vue&type=script&lang=js"
export * from "./folderDetails.vue?vue&type=script&lang=js"
import style0 from "./folderDetails.vue?vue&type=style&index=0&id=0861470a&prod&lang=scss&scoped=true"
import style1 from "./folderDetails.vue?vue&type=style&index=1&id=0861470a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0861470a",
  null
  
)

export default component.exports